export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_RES = 'CHANGE_PASSWORD_RES'
export const RESET_LOADER_STATUS="RESET_LOADER_STATUS"